export { default } from './ponyfillGlobal';